export default __webpack_public_path__ + "static/media/taurus.cea78ff4.png";